const baseDomain =  process.env.VUE_APP_baseDomain   //'posting-api-test.adx-co.jp' //"ato-auto-estimate.107.jp"
const orikomiDomain =  process.env.VUE_APP_orikomiDomain     //'newspaper-api.107.jp'
const paymentDomain =   process.env.VUE_APP_paymentDomain  // 'ato-payment-test-api.107.jp'
const clientManagementDomain =   process.env.VUE_APP_clientManagementDomain   // 'ato-client-management.107.jp'
const geenieDomain =   process.env.VUE_APP_geenieDomain //'dsp-api.107.jp'
const storageDomain = process.env.VUE_APP_storageDomain    //'storage-api.adx-co.jp'
const storeUrl = process.env.VUE_APP_STORE_URL
const orikomiDomainWSS = process.env.VUE_APP_orikomiDomainWSS
const storageDomainWSS = process.env.VUE_APP_storageDomainWSS

export { baseDomain, orikomiDomain, paymentDomain,clientManagementDomain, geenieDomain,storageDomain, storeUrl, orikomiDomainWSS, storageDomainWSS }
